import type { TransactionListItem } from 'generated/reactQueryClient'

const DUST_THRESHOLD = 0.0001

export const detectSuspiciousTransactions = (
  transactions: Array<TransactionListItem>,
  userAddress: string
) => {
  const sortedTransactions = transactions.sort((a, b) => a.timestamp - b.timestamp)

  return sortedTransactions.reduce(
    (acc, tx) => {
      const { knownAddresses, suspiciousTransactions } = acc
      const address = tx.to

      // Skip OP system contracts
      if (address.startsWith('0x4200')) {
        return acc
      }

      if (Number(tx.value) <= DUST_THRESHOLD) {
        const isSuspicious = [...knownAddresses].some((knownAddress) => {
          const addressPrefix = address.substring(0, 6)
          const knownAddressPrefix = knownAddress.substring(0, 6)

          const addressSuffix = address.substring(address.length - 4)
          const knownAddressSuffix = knownAddress.substring(knownAddress.length - 4)

          return addressPrefix === knownAddressPrefix || addressSuffix === knownAddressSuffix
        })

        if (isSuspicious) {
          return {
            knownAddresses,
            suspiciousTransactions: [...suspiciousTransactions, tx],
          }
        }
      }

      knownAddresses.add(address)
      return {
        knownAddresses,
        suspiciousTransactions,
      }
    },
    {
      knownAddresses: new Set([userAddress]),
      suspiciousTransactions: [] as TransactionListItem[],
    }
  ).suspiciousTransactions
}
